import React from 'react';
import IconProps from '../../icons';

const MessageHeartCircle = ({
  width = 24,
  color = 'var(--gray-light-700)',
  className = '',
}: IconProps): JSX.Element => (
  <svg
    className={className}
    width={width}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.9986 11.5264C20.9986 16.2208 17.1931 20.0264 12.4986 20.0264C11.4219 20.0264 10.3919 19.8261 9.4438 19.4609C9.27047 19.3941 9.1838 19.3607 9.11488 19.3449C9.04709 19.3292 8.99802 19.3227 8.92851 19.32C8.85783 19.3173 8.78029 19.3254 8.62521 19.3414L3.50419 19.8707C3.01595 19.9212 2.77183 19.9464 2.62782 19.8586C2.5024 19.7821 2.41697 19.6543 2.39423 19.5091C2.36812 19.3425 2.48477 19.1266 2.71808 18.6947L4.35374 15.6672C4.48844 15.4179 4.5558 15.2932 4.5863 15.1733C4.61643 15.0549 4.62371 14.9696 4.61408 14.8478C4.60432 14.7245 4.55022 14.564 4.44202 14.243C4.1545 13.39 3.99865 12.4764 3.99865 11.5264C3.99865 6.83195 7.80423 3.02637 12.4986 3.02637C17.1931 3.02637 20.9986 6.83195 20.9986 11.5264Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.4956 8.97562C11.5959 7.93677 10.0955 7.65732 8.96826 8.6086C7.84099 9.55987 7.68228 11.1504 8.56754 12.2754C9.11598 12.9725 10.4925 14.2455 11.4606 15.1133C11.8162 15.4321 11.994 15.5915 12.2074 15.6557C12.3904 15.7108 12.6007 15.7108 12.7838 15.6557C12.9971 15.5915 13.1749 15.4321 13.5305 15.1133C14.4986 14.2455 15.8751 12.9725 16.4236 12.2754C17.3088 11.1504 17.1695 9.54986 16.0229 8.6086C14.8762 7.66733 13.3953 7.93677 12.4956 8.97562Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default MessageHeartCircle;
